var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"deleteSubject",staticClass:"btn btn-danger btn-sm",on:{"click":_vm.destroySubject}},[_vm._v("Delete")])}
var staticRenderFns = []

export { render, staticRenderFns }